<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t('components.CompareSimulations.comparePlans') }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-select v-model="simulation1" :items="simulationsArray" :label="$t('components.CompareSimulations.plan1')" item-text="name" item-value="id" return-object>
                <template v-slot:selection="{ item }">
                  <span v-if="item.media_plan">
                    <v-icon class="mr-1">mdi-calculator</v-icon> <v-tooltip v-if="item.optimizer_version === 2" bottom><template v-slot:activator="{ on }"><v-chip x-small color="primary" outlined class="mr-1 flex-shrink-0" style="height: 16px; font-size: 10px;" v-on="on">beta</v-chip></template>{{ $t('components.CompareSimulations.betaOptimizerTooltip') }}</v-tooltip>{{ item.name }}
                  </span>
                  <span v-else>
                    <v-icon class="mr-1">mdi-engine</v-icon> <v-tooltip v-if="item.optimizer_version === 2" bottom><template v-slot:activator="{ on }"><v-chip x-small color="primary" outlined class="mr-1 flex-shrink-0" style="height: 16px; font-size: 10px;" v-on="on">beta</v-chip></template>{{ $t('components.CompareSimulations.betaOptimizerTooltip') }}</v-tooltip>{{ item.name }}
                  </span>
                </template>
                <template v-slot:item="{ item }">
                  <span v-if="item.media_plan">
                    <v-icon class="mr-1">mdi-calculator</v-icon> <v-tooltip v-if="item.optimizer_version === 2" bottom><template v-slot:activator="{ on }"><v-chip x-small color="primary" outlined class="mr-1 flex-shrink-0" style="height: 16px; font-size: 10px;" v-on="on">beta</v-chip></template>{{ $t('components.CompareSimulations.betaOptimizerTooltip') }}</v-tooltip>{{ item.name }} <span class="caption grey--text lighten-1">{{ formatDateFromNow(item.date_created) }}</span>
                  </span>
                  <span v-else>
                    <v-icon class="mr-1">mdi-engine</v-icon> <v-tooltip v-if="item.optimizer_version === 2" bottom><template v-slot:activator="{ on }"><v-chip x-small color="primary" outlined class="mr-1 flex-shrink-0" style="height: 16px; font-size: 10px;" v-on="on">beta</v-chip></template>{{ $t('components.CompareSimulations.betaOptimizerTooltip') }}</v-tooltip>{{ item.name }} <span class="caption grey--text lighten-1">{{ formatDateFromNow(item.date_created) }}</span>
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-select v-model="simulation2" :items="simulationsArray" :label="$t('components.CompareSimulations.plan2')" item-text="name" item-value="id" return-object>
                <template v-slot:selection="{ item }">
                  <span v-if="item.media_plan">
                    <v-icon class="mr-1">mdi-calculator</v-icon> <v-tooltip v-if="item.optimizer_version === 2" bottom><template v-slot:activator="{ on }"><v-chip x-small color="primary" outlined class="mr-1 flex-shrink-0" style="height: 16px; font-size: 10px;" v-on="on">beta</v-chip></template>{{ $t('components.CompareSimulations.betaOptimizerTooltip') }}</v-tooltip>{{ item.name }}
                  </span>
                  <span v-else>
                    <v-icon class="mr-1">mdi-engine</v-icon> <v-tooltip v-if="item.optimizer_version === 2" bottom><template v-slot:activator="{ on }"><v-chip x-small color="primary" outlined class="mr-1 flex-shrink-0" style="height: 16px; font-size: 10px;" v-on="on">beta</v-chip></template>{{ $t('components.CompareSimulations.betaOptimizerTooltip') }}</v-tooltip>{{ item.name }}
                  </span>
                </template>
                <template v-slot:item="{ item }">
                  <span v-if="item.media_plan">
                    <v-icon class="mr-1">mdi-calculator</v-icon> <v-tooltip v-if="item.optimizer_version === 2" bottom><template v-slot:activator="{ on }"><v-chip x-small color="primary" outlined class="mr-1 flex-shrink-0" style="height: 16px; font-size: 10px;" v-on="on">beta</v-chip></template>{{ $t('components.CompareSimulations.betaOptimizerTooltip') }}</v-tooltip>{{ item.name }} <span class="caption grey--text lighten-1">{{ formatDateFromNow(item.date_created) }}</span>
                  </span>
                  <span v-else>
                    <v-icon class="mr-1">mdi-engine</v-icon> <v-tooltip v-if="item.optimizer_version === 2" bottom><template v-slot:activator="{ on }"><v-chip x-small color="primary" outlined class="mr-1 flex-shrink-0" style="height: 16px; font-size: 10px;" v-on="on">beta</v-chip></template>{{ $t('components.CompareSimulations.betaOptimizerTooltip') }}</v-tooltip>{{ item.name }} <span class="caption grey--text lighten-1">{{ formatDateFromNow(item.date_created) }}</span>
                  </span>
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row v-if="availableTabs.length > 0">
            <v-col cols="12">
              <v-tabs v-model="currentTab" class="mb-2 mt-2">
                <v-tab v-for="tab in availableTabs" :key="tab.key">
                  {{ $t(`components.CompareSimulations.${tab.key}`) }}
                </v-tab>
              </v-tabs>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="6" md="6" style="border-right-style: dotted; border-right-width: 1px;">
              <compare-simulations-column :simulation="simulation1" :colors="colors" :spend-unit-name="spendUnitName" v-if="'name' in simulation1" :client="client" :custom-kpi-name="customKpiName" :active-section="activeSection"/>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <compare-simulations-column :simulation="simulation2" :colors="colors" :spend-unit-name="spendUnitName" v-if="'name' in simulation2" :client="client" :custom-kpi-name="customKpiName" :active-section="activeSection"/>
              <span v-else>{{ $t('components.CompareSimulations.selectPlanToCompare') }}</span>
            </v-col>
          </v-row>
        </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'
import CompareSimulationsColumn from '@/components/CompareSimulationsColumn.vue'

export default {
  data () {
    return {
      simulation1: this.selectedSimulation,
      simulation2: {},
      currentTab: 0
    }
  },
  components: {
    CompareSimulationsColumn
  },
  computed: {
    referenceModelConfig () {
      if (this.client.plan_reference_model) {
        return this.client.plan_reference_model.config
      } else {
        return this.client.reference_model.config
      }
    },
    simulationsArray () {
      return Object.values(this.simulations)
    },
    spendUnitName: function () {
      if ('invest_unit_name' in this.referenceModelConfig) {
        return this.referenceModelConfig.invest_unit_name
      } else {
        return null
      }
    },
    loadedSimulations () {
      const sims = []
      if (this.simulation1 && 'name' in this.simulation1) sims.push(this.simulation1)
      if (this.simulation2 && 'name' in this.simulation2) sims.push(this.simulation2)
      return sims
    },
    availableTabs () {
      if (this.loadedSimulations.length === 0) return []
      const candidates = [
        { key: 'fullPeriodSummary', check: () => true },
        { key: 'monthlyDetailView', check: sim => this.hasMonthlyDetail(sim) },
        { key: 'weeklyDetailView', check: sim => this.hasWeeklyDetail(sim) },
        { key: 'touchpoints', check: sim => this.hasTouchpoints(sim) },
        { key: 'segments', check: sim => this.hasSegments(sim) }
      ]
      return candidates
        .filter(c => this.loadedSimulations.every(sim => c.check(sim)))
        .map(c => ({ key: c.key }))
    },
    activeSection () {
      if (this.availableTabs.length === 0) return 'fullPeriodSummary'
      const tab = this.availableTabs[this.currentTab] || this.availableTabs[0]
      return tab.key
    }
  },
  watch: {
    'availableTabs.length' (newLen) {
      if (this.currentTab >= newLen) {
        this.currentTab = 0
      }
    }
  },
  methods: {
    formatDateFromNow (date) {
      return moment(date).fromNow()
    },
    closeDialog () {
      this.$emit('close-dialog')
    },
    hasMonthlyDetail (sim) {
      const r = sim.results
      return !!(r && r.invest && r.invest.media_spend && r.invest.time && Object.keys(r.invest.time).length > 1)
    },
    hasWeeklyDetail (sim) {
      const r = sim.results
      return !!(r && r.weekly_detail && r.weekly_detail.sales && r.weekly_detail.sales.time && Object.keys(r.weekly_detail.sales.time).length > 1)
    },
    hasTouchpoints (sim) {
      const r = sim.results
      if (!r || !r.invest || !r.invest.mix) return false
      const firstKey = Object.keys(r.invest.mix)[0]
      return !!(firstKey && r.invest.mix[firstKey] && r.invest.mix[firstKey].touchpoints)
    },
    hasSegments (sim) {
      const r = sim.results
      if (!r) return false
      if (r.invest && r.invest.segments) return true
      if (!r.sales) return false
      const outputs = r.sales.outputs ? Object.values(r.sales.outputs) : [r.sales]
      for (const out of outputs) {
        if (!out) continue
        if (out.microaudience) return true
        if (out.marketing) {
          const firstChannel = Object.keys(out.marketing)[0]
          if (firstChannel && out.marketing[firstChannel] && out.marketing[firstChannel].segments) return true
        }
      }
      return false
    }
  },
  directives: {},
  props: {
    selectedSimulation: {
      type: Object,
      required: true
    },
    simulations: {
      type: Array,
      required: true
    },
    colors: {
      type: Object,
      required: true
    },
    client: {
      type: Object,
      required: true
    },
    customKpiName: {
      type: String,
      required: true
    }
  },
  created: function () {
    console.log('Created')
  }
}
</script>
